import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { LoginForm } from "../apps/customer-account/LoginForm";
import { isoWebPageURL } from "../models/nominals";

export const Template = (
    props: Immutable<templates.LoginStandaloneTemplate>,
): React.JSX.Element => {
    return (
        <LoginForm
            nextURL={isoWebPageURL.wrap(props.next_url)}
            initialEmail={props.initial_email}
        />
    );
};
